module.exports = __webpack_public_path__ + "static/FishermanWhiteIconLogo-5efc645be19a95b275ad4660799cef5c.png";